import { Brand } from 'models/brands';
import { Marketplace } from 'models/marketplaces';
import { Country } from 'models/countries';
import { FulfillmentMethod } from 'models/fulfillmentMethods';
import { Gender } from 'models/genders';
import { AgeGroup } from 'models/ageGroups';
import { Season } from 'models/seasons';
import { StateCreator } from 'zustand/vanilla';
import { Category } from 'models/categories';

export interface FilterLists {
  allBrands: Brand[];
  allMarketplaces: Marketplace[];
  allCountries: Country[];
  allCategories: Category[];
  allFulfillmentMethods: FulfillmentMethod[];
  allGenders: Gender[];
  allAgeGroups: AgeGroup[];
  allSeasons: Season[];
}
export interface FilterListsActions {
  setAllBrands: (brands: Brand[]) => void;
  setAllCountries: (countries: Country[]) => void;
  setAllGenders: (genders: Gender[]) => void;
  setAllAgeGroups: (ageGroups: AgeGroup[]) => void;
  setAllSeasons: (seasons: Season[]) => void;
  setAllMarketplaces: (marketplaces: Marketplace[]) => void;
  setAllFulfillmentMethods: (allFulfillmentMethods: FulfillmentMethod[]) => void;
  setAllCategories: (allCategories: Category[]) => void;
}

export const emptyFilterLists: FilterLists = {
  allBrands: [],
  allMarketplaces: [],
  allCountries: [],
  allCategories: [],
  allFulfillmentMethods: [],
  allGenders: [],
  allAgeGroups: [],
  allSeasons: [],
};

export interface FilterListsSlice extends FilterLists, FilterListsActions {}

export const createFilterListsSlice: StateCreator<FilterListsSlice, [], [], FilterListsSlice> = set => ({
  ...emptyFilterLists,
  setAllBrands: brands => set(() => ({ allBrands: brands })),
  setAllCountries: countries => set(() => ({ allCountries: countries })),
  setAllGenders: genders => set(() => ({ allGenders: genders })),
  setAllAgeGroups: ageGroups => set(() => ({ allAgeGroups: ageGroups })),
  setAllSeasons: seasons => set(() => ({ allSeasons: seasons })),
  setAllMarketplaces: marketplaces => set(() => ({ allMarketplaces: marketplaces })),
  setAllCategories: categories => set(() => ({ allCategories: categories })),
  setAllFulfillmentMethods: fulfillmentMethods => set(() => ({ allFulfillmentMethods: fulfillmentMethods })),
});
